import { useEffect } from "react";
import { useQuery } from "react-query";
import { IncomingSocketEvent, socket } from "../../../app/sockets/socket";
import { getInquiries } from "../../../utils/axios-requests";

export const useInquiryCount = () => {
  // queryFn to return the data directly (the entire response object or just the data).
  // let React Query store the inquiry data (the array).
  const inquirieQuery = useQuery({
    queryKey: "inquiries",
    queryFn: async () => {
      const res = await getInquiries();
      // return the array of inquiries here.
      return res.data;
    },
    // the query to run immediately on mount to get the initial count.
    // Setting 'enabled: true' (or removing it, as true is default) is the standard approach.
    // If you MUST manually refetch, keep enabled: false, but the initial call needs to be outside the refetch.
    enabled: true,
    // Set a default/initial value for the data
    initialData: undefined, // initialData: [],
    // Add a stale time so it doesn't refetch on every re-render (optional but good practice)
    staleTime: 10000 * 60 // 10 minutes in milliseconds
  });

  // Handle the socket logic. This now only calls refetch.
  useEffect(() => {
    // React Query handles the initial fetch because enabled is true.
    const handleConnectionsUpdated = () => {
      inquirieQuery.refetch();
    };

    socket.on(IncomingSocketEvent.ConnectionsUpdated, handleConnectionsUpdated);

    return () => {
      socket.off(IncomingSocketEvent.ConnectionsUpdated, handleConnectionsUpdated);
    };

    // Dependencies: inquirieQuery is a stable object provided by React Query, but include it for safety.
  }, [inquirieQuery]);

  // Return the calculated count based on query data.
  // If data is loading or undefined, default to 0.
  const inquiryCount = inquirieQuery.data ? inquirieQuery.data.length : 0;

  const inquiryRefetch = inquirieQuery.refetch;

  return { inquiryCount, inquiryRefetch };
};
